/**
 * Selo de status/rótulo (primitivo do redesign admin). Sempre acompanha texto —
 * cor nunca é o único indicador. Tons semânticos usam os `*-soft` locais.
 */
import { createElement as h, type ReactElement, type ReactNode } from "react";
import { cx } from "./cx.js";

export type BadgeTone = "neutral" | "brand" | "success" | "warning" | "danger" | "info";

const TONE: Record<BadgeTone, string> = {
  neutral: "bg-surface-soft text-ink",
  brand: "bg-brand-wash text-brand-text",
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  danger: "bg-danger-soft text-danger",
  info: "bg-info-soft text-info"
};

export interface BadgeProps {
  tone?: BadgeTone;
  children?: ReactNode;
  className?: string;
  title?: string;
  [dataAttr: `data-${string}`]: string | number | boolean | undefined;
}

export function Badge({ tone = "neutral", children, className, ...rest }: BadgeProps): ReactElement {
  return h(
    "span",
    { ...rest, className: cx("inline-flex items-center gap-1 whitespace-nowrap rounded-pill px-2.5 py-0.5 text-xs font-bold leading-5", TONE[tone], className) },
    children
  );
}
